import React, { Suspense } from 'react';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import { SuspenseFallback } from '@/shared/ui/SuspenseFallback';

import { DataAssetsOverview } from '@/widgets/home/DataAssetsOverview';
import { DataServicesOverview } from '@/widgets/home/DataServicesOverview';
import { FavoritesCard } from '@/widgets/home/FavoritesCard';
import { MyAssetsCard } from '@/widgets/home/MyAssetsCard';
import { RecentAssetsCard } from '@/widgets/home/RecentAssetsCard';
import { TagDistributionOverview } from '@/widgets/home/TagDistributionOverview';

import styles from './HomePage.module.css';

export const HomePage: React.FC = () => {
  return (
    <div className={styles.homePage}>
      <div className={styles.header}>
        <div className={styles.title}>cyclone 데이터 플랫폼에 오신 것을 환영합니다</div>
        <div className={styles.description}>데이터 자산을 한곳에서 탐색하고 효율적으로 관리하세요.</div>
      </div>

      <div className={styles.mainContent}>
        <div className={styles.topRow}>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.DATA_ASSETS_OVERVIEW_ERROR}
            description={NOTIFICATION_MESSAGES.DATA_ASSETS_OVERVIEW_ERROR_DESC}>
            <Suspense fallback={<SuspenseFallback />}>
              <DataAssetsOverview />
            </Suspense>
          </ErrorBoundary>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.TAG_DISTRIBUTION_ERROR}
            description={NOTIFICATION_MESSAGES.TAG_DISTRIBUTION_ERROR_DESC}>
            <Suspense fallback={<SuspenseFallback />}>
              <TagDistributionOverview />
            </Suspense>
          </ErrorBoundary>
        </div>

        <div className={styles.bottomRow}>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.RECENT_ASSETS_ERROR}
            description={NOTIFICATION_MESSAGES.RECENT_ASSETS_ERROR_DESC}>
            <RecentAssetsCard />
          </ErrorBoundary>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.FAVORITES_ERROR}
            description={NOTIFICATION_MESSAGES.FAVORITES_ERROR_DESC}>
            <FavoritesCard />
          </ErrorBoundary>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.MY_ASSETS_ERROR}
            description={NOTIFICATION_MESSAGES.MY_ASSETS_ERROR_DESC}>
            <MyAssetsCard />
          </ErrorBoundary>
          <ErrorBoundary
            title={NOTIFICATION_MESSAGES.DATA_SERVICES_ERROR}
            description={NOTIFICATION_MESSAGES.DATA_SERVICES_ERROR_DESC}>
            <Suspense fallback={<SuspenseFallback />}>
              <DataServicesOverview />
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};
